export default __webpack_public_path__ + "static/media/ugo-junction.b1bfccd0.svg";